export const setParamsToWindow = () => {
    window.HIDE_FRONT_CHAT = import.meta.env.HIDE_FRONT_CHAT;
};
